module.exports = __webpack_public_path__ + "static/media/company_selected.e2b5de59.svg";